import type { AxiosResponse } from 'axios'
import type { Customers, Customer, PaginationParams, Pagination, CertificateAdmin } from 'types'

export enum ActionType {
  GET_CUSTOMERS = 'GET_CUSTOMERS',
  SET_CUSTOMERS = 'SET_CUSTOMERS',

  GET_CUSTOMER = 'GET_CUSTOMER',
  SET_CUSTOMER = 'SET_CUSTOMER',

  CREATE_CUSTOMER = 'CREATE_CUSTOMER',
  UPDATE_CUSTOMER = 'UPDATE_CUSTOMER',
}

export type GetCustomersPayload = {
  query?: string | null
} & PaginationParams

export type CustomerDataResponse = {
  customer: Customer
  certificates: {
    data: CertificateAdmin[]
  } & Pagination
}

export type GetCustomersResponse = AxiosResponse<Customers>

export type GetCustomerByIdPayload = {
  customerId: string
} & PaginationParams

export type GetCustomerByIdResponse = AxiosResponse<CustomerDataResponse>

export type CreateCustomerPayload = Customer

export type CreateLeanCustomerPayload = Pick<Customer, 'email'>

export type CreateCustomerManualPayload = {
  full_name: string
  age?: number
  gender?: string
  email: string
  phone: string
  invite_owner?: boolean
  photo?: File | null
}

export type UpdateCustomerPayload = {
  id: string
  fullName: string
  age?: number
  gender?: string
  email: string
  phone: string
  inviteOwner?: boolean
}

export type CreateCustomerResponse = AxiosResponse<Customer>
export type UpdateCustomerResponse = AxiosResponse<{
  id: string
  fullName: string
  age?: number
  gender?: string | null
  email: string
  phone: string
  status: string
  registrationDate: string
  invitationQueued?: boolean
  warnings?: string[]
}>
